import { render, staticRenderFns } from "./alocacao.vue?vue&type=template&id=76994b90&scoped=true&"
import script from "./alocacao.vue?vue&type=script&lang=js&"
export * from "./alocacao.vue?vue&type=script&lang=js&"
import style0 from "./alocacao.vue?vue&type=style&index=0&id=76994b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76994b90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
